
export const RESULT_EMAIL = `Dear <firstName>,

Thank you for completing the Business Impact Survey for <orgName>.

Your can view your results here: <link>

Thank you,

ZeroBees Team
`

export const RESULT_EMAIL_SUBJECT = `ZeroBees | Your Business Impact Survey Results`

export const RESULT_EMAIL_ADMIN = `Dear <firstName>,

Thank you for completing the Business Impact Survey for <orgName>.

Admin has reviewed your results based on the information you have provided.

Your can view your results here: <link>

Thank you,

ZeroBees Team
`


export const ESG_SUBMITTED_FOR_VALIDATION_EMAIL = `Dear <firstName>,

Thank you for submitting your ESG assessment for validation through the Business Impact Tracker from ZeroBees.

Once your payment is confirmed, we'll let you know who your analyst is.

Here’s what happens now:

We'll assign you an analyst within 3 working days, and they'll be in touch within the next 3 weeks to ask for clarifications or further evidence - by email and potentially scheduling a call where needed. Please feel free to request a call once you have the details of your analyst if you need further support.
Your analyst will assess your evidence and proposed score against our framework. We’ll be looking to discuss with you where your evidence may be insufficient or even where you may score better than you proposed. You'll have an opportunity to submit further evidence or discuss the question further with the analyst. You can escalate issues with ZeroBees upon request, but the decision of the escalation manager is final.
Expect verification to take between 3 weeks and 3 months from submission. The cut-off for additional evidence if 3 months post submission, at which point your score will become finalised. This time to verification will depend on how complete your evidence base is, as well as the number of organisations going through accreditation at the time.
Once verification of your score is complete, your score will be ready for disclosure.

Best regards,

ZeroBees Team
`